module.exports = __webpack_public_path__ + "img/archiveTxt.92b9c6e0.png";